var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import PropTypes from "prop-types";
import { StyledTextField, ErrorMessage, Label, SuccessText, StyledDiv, } from "./va-text-field-style";
const VaTextField = (props) => {
    // variables & states
    const { label, passwordInput, error, errorMessage, successMessage, backgroundColor, round, height, multiline, row, ref, icon = null, labelRender, endAdornment } = props, otherProps = __rest(props, ["label", "passwordInput", "error", "errorMessage", "successMessage", "backgroundColor", "round", "height", "multiline", "row", "ref", "icon", "labelRender", "endAdornment"]);
    const [showPassword, setShowPassword] = useState(false);
    // functions
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (_jsxs(StyledDiv, { children: [labelRender && !icon && _jsx(Label, { children: label }), labelRender && icon && (_jsxs("div", { style: { display: "flex", alignItems: "center", color: 'rgb(142, 149, 170)' }, children: [_jsx(Label, { children: label }), icon] })), _jsx(StyledTextField, Object.assign({ ref: ref, backgroundColor: backgroundColor, height: height, multiline: multiline, rows: row, type: showPassword || !passwordInput ? "text" : "password", round: round, InputProps: {
                    endAdornment: passwordInput ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end", children: showPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) }) })) : endAdornment ? endAdornment : undefined
                }, error: error }, otherProps)), !!errorMessage && _jsx(ErrorMessage, { error: error, children: errorMessage }), !!successMessage && _jsx(SuccessText, { successMessage: successMessage, children: successMessage.successText })] }));
};
VaTextField.propTypes = {
    label: PropTypes.string,
    passwordInput: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    labelRender: PropTypes.bool,
};
VaTextField.defaultProps = {
    labelRender: true,
};
export default VaTextField;
